'use strict';

var __chunk_6 = require('./chunk-fac2c876.js');

/**
 * Converts the list of `as` to a list of type `t`.
 *
 * @private
 */
function toList(as, t) {
  return t === 'string' ? as.join('') : as;
}

function sortBy(c, as) {
  var bs = Array.from(as.slice(0));
  return toList(bs.sort(c), __chunk_6._typeof(as));
}

module.exports = sortBy;
